// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_784","cls2":"SimplePaperPodcast-cls2_i2n SimplePaperPodcast-cls1_784"};